import { Navbar } from "react-bootstrap";
import Footer from "../../components/Footer/Footer";
import SecurityHero from "../../components/Security/Security";
import { ValuesandPrinciples1 } from "../Business/ValuesPrinciples/ValuesandPrinciples";

function Security() {
  return (
    <div className="Landing-page-all">
      <Navbar />
      <SecurityHero />
      <ValuesandPrinciples1 />
      <Footer />
    </div>
  );
}

export default Security;
